import { type Translationtype } from "utils";
import { Tooltip } from "../components/tooltip";

interface IFormTextareaProps {
  register: any;
  errors: any;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  name: string;
  title: string;
  tooltip?: string;
  t: Translationtype;
}

export function FormTextarea({
  register,
  errors,
  className,
  disabled,
  placeholder,
  name,
  title,
  tooltip,
  t,
}: IFormTextareaProps) {
  return (
    <div className={`${className || ""} w-full`}>
      <label htmlFor={name} className="w-full block mb-1 text-textColor">
        {title}
        {tooltip ? <Tooltip text={tooltip} /> : null}
      </label>
      <textarea
        id={name}
        disabled={disabled || false}
        className="input  w-full  h-[200px] p-[10px]"
        placeholder={placeholder || ""}
        {...register(name)}
      />
      {errors[`${name}`]?.message ? (
        <p className="text-sm my-3 text-error">
          {t(`${errors[`${name}`]?.message}` as any)}
        </p>
      ) : null}
    </div>
  );
}
